import React from "react";
import PropTypes from "prop-types";
import FilterDropDown from "./FilterDropDown";
import { useTranslation } from "react-i18next";

/**
 * FilterBar Molecule - Container for filter controls
 */
const FilterBar = ({
  sortValue,
  countryValue,
  onSortChange,
  onCountryChange,
  sortOptions,
  countryOptions,
  showCountryFilter = false,
}) => {
  const { t } = useTranslation();

  const sortKeyMap = {
    priceAsc: "filters.priceLowHigh",
    priceDesc: "filters.priceHighLow",
    loveAsc: "filters.heartsLowHigh",
    loveDesc: "filters.heartsHighLow",
  };

  // Convert options to FilterDropDown format with translated labels
  const sortDropdownOptions = sortOptions.map((option) => ({
    ...option,
    label: t(sortKeyMap[option.value] || option.label),
    action: () => onSortChange(option.value),
  }));

  const countryDropdownOptions = countryOptions.map((option) => ({
    ...option,
    label:
      option.value === "All"
        ? t("country.country")
        : option.value === "Worldwide"
        ? t("country.worldwide")
        : option.label,
    action: () => onCountryChange(option.value),
  }));

  const getSortLabel = () => {
    if (!sortValue) return t("career.sort");
    return t(sortKeyMap[sortValue]) || t("sort.sort");
  };

  const getCountryLabel = () => {
    if (countryValue === "All") return t("country.country");
    if (countryValue === "Worldwide") return t("country.worldwide");
    return countryValue;
  };

  return (
    <div className="flex justify-around mb-5">
      <FilterDropDown
        buttonLabel={getSortLabel()}
        options={sortDropdownOptions}
      />
      {showCountryFilter && (
        <FilterDropDown
          buttonLabel={getCountryLabel()}
          options={countryDropdownOptions}
        />
      )}
    </div>
  );
};

FilterBar.propTypes = {
  sortValue: PropTypes.string,
  countryValue: PropTypes.string,
  onSortChange: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  sortOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string,
    })
  ).isRequired,
  countryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string,
    })
  ).isRequired,
  showCountryFilter: PropTypes.bool,
};

export default FilterBar;
